import { Clickable, Icon, Row, Text } from 'components';
import { theme } from 'lib';
import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  width: 100%;
  min-height: ${(props) => (props.error ? '42px' : '43px')};
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;
  border: ${(props) => (props.error ? `2px solid ${theme.SECONDARY}` : '1px')};
  border-radius: 50px;
  font-size: 16px;
  background-color: ${theme.GREY_10};
  height: 40px;

  ${(props) =>
    props.multiline &&
    `
    border-radius: 16px;
    ${props.numberOfLines && `max-height: ${(props.isFocused ? 42 : 43) * props.numberOfLines}px;`}
  `};

  ${(props) =>
    props.ht &&
    `
    height: ${props.ht};
    align-items: flex-start;
  `}
`;

const StyledInput = styled.input`
  font-family: CeraPro;
  flex: 1;
  width: 100%;
  font-size: 16px;
  ${(props) => props.center && `text-align: center;`};

  ${(props) =>
    props.multiline &&
    `
    padding: 10px 0;
  `};
`;

const SearchInput = (props) => {
  return (
    <React.Fragment>
      {props.title && (
        <Text b2 med marg={props.rounded ? '0 0 8px' : '0 0 8px 16px'}>
          {props.title}
        </Text>
      )}

      <Container {...props}>
        <Row center between wid="100%" pad="0 16px">
          <Clickable onClick={props.hasBack} disabled={!props.hasBack}>
            {props.hasBack ? (
              <Icon type="arrowLeft" dimensions={16} col="#000" marg="0 11.5px 0 0" />
            ) : (
              <Icon type="search" dimensions={17.5} col={theme.GREY_50} marg="0 11.5px 0 0" />
            )}
          </Clickable>

          <StyledInput
            {...props}
            placeholderTextColor={theme.GREY_60}
            placeholderStyle={{ fontSize: 16 }}
            ref={props.inputRef}
          />

          {props.hasRemove && !!props.value?.length && (
            <Clickable onClick={() => props.onChange({ target: { value: '' } })}>
              <Icon type="close" dimensions={14} col={theme.GREY_50} />
            </Clickable>
          )}
        </Row>
      </Container>

      {props.error && (
        <Row noFlex>
          <Text c1 bold marg="4px 0 0 16px" col={theme.SECONDARY}>
            {props.error}
          </Text>
        </Row>
      )}
    </React.Fragment>
  );
};

export default SearchInput;
